export default "__VITE_ASSET__cGOxomBF__"